import moment from "moment/moment";
import { getEnv } from "./env";
import { createItem, updateObj } from "./utils";

const LISTENERS = new Map();

import localesChart from '../locales/current/chart.json';
import localesCommon from '../locales/current/common.json';
import localesHome from '../locales/current/home.json';
import localesInfoPage from '../locales/current/info-page.json';
import localesProfile from '../locales/current/profile.json';
import localesModals from '../locales/current/modals.json';
import localesErrors from '../locales/current/errors.json';

const LOCALES_MAP = {
    'chart': localesChart,
    'common': localesCommon,
    'home': localesHome,
    'info-page': localesInfoPage,
    'profile': localesProfile,
    'modals': localesModals,
    'errors': localesErrors,
}

// const LOCALES_LIST = [
//     'chart',
//     'common',
//     'home',
//     'info-page',
//     'profile',
//     'modals',
//     'errors'
// ];

let CURRENT_LANGUAGE;

let LOCALIZED_TEXTS = {};

export function initCurrentLanguage() {
    addCurrentLanguageListener(updateLangItems)
    return setCurrentLanguage(getEnv('LANG'));
}

export async function setCurrentLanguage(language) {
    CURRENT_LANGUAGE = language;
    moment.locale(CURRENT_LANGUAGE);

    LOCALIZED_TEXTS = {};

    const locales = Object.values(LOCALES_MAP);
    // const locales = await Promise.all(LOCALES_LIST.map(async (file) => {
    //     return (await import(`../locales/${CURRENT_LANGUAGE}/${file}.json`)).default;
    // }));
    locales.forEach(l => {
        LOCALIZED_TEXTS = updateObj(LOCALIZED_TEXTS, l);
    });

    for (const listener of LISTENERS.values()) {
        listener(CURRENT_LANGUAGE)
    }
}

/**
 * Add listener for setCurrentTheme event
 * Returns unsubscribe function
 */
export function addCurrentLanguageListener(listener) {
    const key = Symbol();
    LISTENERS.set(key, listener);
    return function() {
        LISTENERS.delete(key)
    }
}

export function getCurrentLanguage() {
    return CURRENT_LANGUAGE;
}

function updateLangItems() {
    setTimeout(() => {
        document.querySelectorAll('.localized_item').forEach(function (el) {
            var key = el.getAttribute('data-source-text'),
                localized = LOCALIZED_TEXTS[key];

            if (LOCALIZED_TEXTS[key]) {
                el.innerHTML = localized;
            }
        });
    }, 100)
}

export function lang(item, noTag) {
    noTag = true;
    var localItem = createItem('mark', 'localized_item'),
        helper = createItem('div'),
        localized = item;

    if (LOCALIZED_TEXTS[item]) {
        localized = LOCALIZED_TEXTS[item];
    }

    localItem.setAttribute('data-source-text', item);
    localItem.innerHTML = localized;
    helper.appendChild(localItem);

    if (noTag) {
        helper.innerHTML = localized;
    }

    return helper.innerHTML;
}

export function getLangCode() {
    switch(CURRENT_LANGUAGE) {
        case 'ru':
            return 'ru-RU';
        case 'en':
        default:
            return 'en-US';
    }
}

// export async function langPrompt() {
//     var modal = modalController({inner_cls: 'naked', prompt: true}),
//         form = (await modalTemplates('lang'))({
//             onSubmit: function (lng) {
//                 switch(lng) {
//                     case 'en':
//                         window.location=EN_URL;
//                         break;
//                     case 'ru':
//                         window.location=RU_URL;
//                         break;
//                     case 'id':
//                         window.location=ID_URL;
//                         break;
//                 }
//                 modal.remove();
//             }
//         });

//     modal.container.appendChild(form);
// }
